import React from 'react';
import '../style/header.scss';
import logo from "../images/namelogo.png"; // Tell Webpack this JS file uses this image
import logowings from "../images/logo.png"; // Tell Webpack this JS file uses this image
import { Link } from "gatsby";
import { FaBars } from "react-icons/fa";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem } from 'reactstrap';



  export default class Header extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false,
      brand: "",
      width: 0
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  componentDidMount(){
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    window.addEventListener('scroll', function(e) {
    closeNav();
    })
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth });
  }
  render(){
    let brand;
    if(this.state.width < 600){
      brand = <img src={logowings} className="logo ml-3"/>;
    }else{
      brand = <img src={logo} className="logo ml-5"/>;
    }
    return(
    <>
    <div id="overlay" onClick={closeNav}></div>
    <div id="mySidenav" className="sidenav">
        <a href="javascript:void(0)" className="closebtn" onClick={closeNav}>&times;</a>
        <div className="ml-5 mr-4 faded">
            <h2 className="teko">CROSSFIT DELIVERANCE <span className="ml-2"><img src={logowings} height="50px;" alt="" /></span></h2>
            <span><i className="fa fa-phone mr-2 my-2"></i> 253.686.4898</span>
                  <br/>
                  <span><i className="fa fa-map-marker mr-2 my-2"></i> 4535 Union Bay Pl NE </span>
                  <br/>
                  <span><i className="fa fa-clock-o  mr-2 my-2"></i> Mon - Fri 5:00am - 7:30pm</span>
            <br/>
            <form className="sidemenu-form"action="https://app.wodify.com/API/WebToLeadFormPostEntry_v1.aspx?" accept-charset="UTF-8" method="POST" id="wodifyLeadForm" name="wodifyLeadForm" onsubmit="return validateWodifyLeadForm();">

                    <input type="text" name="name" maxlength="50" required data-required placeholder="Name"/> 
                    <span id="errorname" name="errorname" style={{display: 'none', color: '#cc2626'}}> Required field!</span><br/>
                    <input type="email" name="email" maxlength="250" required data-required placeholder="Email"/> 
                    <span id="erroremail" name="erroremail" style={{display: 'none', color: '#cc2626'}}> Required field!</span><br/>
                    <textarea name="comments" maxlength="2000" rows="4" placeholder="Comment"/>
                    <input type="hidden" name="redirecturl" value="http://crossfitdeliverance.com/rates/"/>
                    <input type="hidden" name="apikey" value="csrdgwz4t6"/>
                    <br/>
                    <button className="primary-button-small" type="submit">Send Message</button>
              </form>
            <hr/>
            <br/>
            <h4 className="teko">FOLLOW US</h4>
                <a href="https://www.facebook.com/crossfitdeliverance/" target="_blank" className="social_media_button social_media_button--light" style={{marginLeft:'0px'}}>
                    <i className="fa fa-facebook"></i>
                </a>
                <a href="https://www.youtube.com/channel/UCJwsU2VvviHvzMa5lPWcIeg/videos" target="_blank" className="social_media_button social_media_button--light">
                    <i className="fa fa-youtube"></i>
                </a>
                <a href="https://www.instagram.com/crossfitdeliverance/" target="_blank" className="social_media_button social_media_button--light">
                    <i className="fa fa-instagram"></i>
                </a>
        </div>
    </div>
    <div id="main">
    <Navbar  light expand="md" className="navbar">
          <NavbarBrand>{brand}</NavbarBrand>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="ml-auto" navbar>
              <NavItem>
                <NavLink><Link  className="navitem" to="/" style={{color: `${this.props.color}`}}>HOME</Link></NavLink>
              </NavItem>
              <UncontrolledDropdown nav inNavbar >
                <DropdownToggle nav className="navitem program dropdown" style={{color: `${this.props.color}`}}>
                  PROGRAMS
                </DropdownToggle>
                <DropdownMenu right>
                    <Link className="navitem ml-3" to="/crossfit" style={{color: `black`}}>CROSSFIT</Link>
                    <br/>
                    <Link className="navitem ml-3" to="/training" style={{color: `black`}}>1-ON-1 COACHING</Link>
                    <br/>
                    <Link className="navitem ml-3" to="/nutrition" style={{color: `black`}}>NUTRITION</Link>
                    <br/>
                    <Link className="navitem ml-3" to="/seminars" style={{color: `black`}}>ACCELORATORS</Link>              
                </DropdownMenu>
              </UncontrolledDropdown>
              <NavItem>
                <NavLink><Link className="navitem" to="/get_started" style={{color: `${this.props.color}`}}>GET STARTED</Link></NavLink>
              </NavItem>
              <NavItem>
                <NavLink><Link className="navitem" to="/schedule" style={{color: `${this.props.color}`}}>SCHEDULE</Link></NavLink>
              </NavItem>
              {/* <NavItem>
                <NavLink><Link className="navitem" to="/blog/page1" style={{color: `${this.props.color}`}}>BLOG</Link></NavLink>
              </NavItem> */}
              <NavItem>
                <NavLink><a className="navitem" href="http://crossfitdeliverance.wodify.com/OnlineSalesPortal/SessionsByLocationEntry.aspx?LocationId=892&OnlineMembershipId=4134
" style={{color: `${this.props.color}`}}>DROP IN</a></NavLink>
              </NavItem>
              <NavItem onClick={openNav} className="mr-5 mt-1 barmenu">
                <NavLink><FaBars style={{color: `${this.props.color}`}}/></NavLink>
              </NavItem>
            </Nav>
          </Collapse>
        </Navbar>
        {/* <div className="sidebar">
                <a href="#" className="social_media_button social_media_button--dark">
                    <i className="fa fa-facebook"></i>
                </a>
                <a href="#" className="social_media_button social_media_button--dark">
                    <i className="fa fa-youtube"></i>
                </a>
                <a href="#" className="social_media_button social_media_button--dark">
                    <i className="fa fa-instagram"></i>
                </a>
        </div> */}
    </div>
          
      </>
    )
  }
}
function validateWodifyLeadForm(){
  var reEmail = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  var returnValue = true;
  var fieldname=document.forms['wodifyLeadForm']['name'].value; if(fieldname==null||fieldname=='') {document.getElementById('errorname').style.display='inline';returnValue=false;} else {document.getElementById('errorname').style.display='none';}var fieldemail=document.forms['wodifyLeadForm']['email'].value;  if(fieldemail==null||fieldemail==''||!reEmail.test(fieldemail)) {document.getElementById('erroremail').style.display='inline';returnValue=false;} else {document.getElementById('erroremail').style.display='none';} return returnValue;
  };


/* Set the width of the side navigation*/
function openNav() {
  document.getElementById("mySidenav").style.width = "400px";
  document.getElementById("overlay").style.display = "block";
}

/* Set the width of the side navigation to 0 */
function closeNav() {
  document.getElementById("mySidenav").style.width = "0";
  document.getElementById("overlay").style.display = "none";
} 


